import { ALL_TARGETS_ID, type LocationId, type TargetLocation } from "../lib/locations";

interface TargetPickerProps {
  locations: TargetLocation[];
  selected: LocationId;
  onSelect: (id: LocationId) => void;
}

export function TargetPicker({ locations, selected, onSelect }: TargetPickerProps) {
  return (
    <div className="picker" role="radiogroup" aria-label="Hedef konum">
      <button
        type="button"
        role="radio"
        aria-checked={selected === ALL_TARGETS_ID}
        className={`picker__item picker__item--wide ${
          selected === ALL_TARGETS_ID ? "picker__item--active" : ""
        }`}
        onClick={() => onSelect(ALL_TARGETS_ID)}
      >
        Tümü
      </button>
      {locations.map((location) => {
        const active = location.id === selected;
        return (
          <button
            key={location.id}
            type="button"
            role="radio"
            aria-checked={active}
            className={`picker__item ${active ? "picker__item--active" : ""}`}
            onClick={() => onSelect(location.id)}
          >
            {location.name}
          </button>
        );
      })}
    </div>
  );
}
